"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyJumpingProjectileAttackWithDamage = void 0;
const Calculators_1 = require("../state/Calculators");
function applyJumpingProjectileAttackWithDamage(args) {
    const { abilityKey, projectileType, projectilePath, attackType, attackerId, targetIds, toApply, onHit, onMiss } = args;
    let { sequence } = args;
    const wrapper = sequence.pushSequence("sequential");
    let lastTargetId = attackerId;
    targetIds.forEach((targetId, i) => {
        const targetSequence = wrapper.pushSequence("parallel");
        const projectiles = Array.of({
            creatorId: lastTargetId,
            targetId,
            jitter: 0,
            path: projectilePath,
            type: projectileType,
        });
        lastTargetId = targetId;
        this.applyAttack({
            attackerId,
            targetId,
            type: i === 0 ? attackType
                : (0, Calculators_1.mkAttackTypeTick)(attackType),
            abilityKey,
            sequence: targetSequence,
            onHit: (hitSequence, _, attack) => this.applyProjectiles({
                sequence: hitSequence,
                projectiles,
                onProjectile: (projectileSequence) => {
                    const { applied } = this.applyAttackDamages({
                        attackType,
                        attackerId,
                        targetId,
                        isCrit: attack.crit,
                        sequence: projectileSequence,
                        toApply
                    });
                    onHit && onHit(projectileSequence, attack, applied, targetId);
                }
            }),
            onMiss: (missSequence, _, attack) => {
                this.applyProjectiles({
                    sequence: missSequence,
                    projectiles,
                    onProjectile: () => {
                        onMiss && onMiss(missSequence, attack, targetId);
                    }
                });
            }
        });
    });
}
exports.applyJumpingProjectileAttackWithDamage = applyJumpingProjectileAttackWithDamage;
